import { render, staticRenderFns } from "./SubgroupDetailForm.vue?vue&type=template&id=2182eee8&"
import script from "./SubgroupDetailForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports